import script from "./highlighted-metric-pill.vue?vue&type=script&setup=true&lang=ts"
export * from "./highlighted-metric-pill.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__